/**
 * TAMIX SAAS PLATFORM - 404 Not Found Page
 * ========================================
 * Generated: 2025-09-22 - Session 6 Sprint 0
 * Error page for invalid routes
 */

import React from 'react'
import { Link } from 'react-router-dom'

const NotFound: React.FC = () => {
  return (
    <div className="container-fluid vh-100 d-flex align-items-center justify-content-center">
      <div className="text-center">
        <div className="mb-4">
          <i className="fas fa-exclamation-triangle fa-5x text-warning"></i>
        </div>
        
        <h1 className="display-4 fw-bold mb-3">404</h1>
        <h2 className="h4 mb-3">Página no encontrada</h2>
        
        <p className="text-muted mb-4">
          La página que buscas no existe o ha sido movida.
        </p>
        
        <div className="d-flex gap-2 justify-content-center">
          <Link to="/dashboard" className="btn btn-primary">
            <i className="fas fa-home me-2"></i>
            Ir al Dashboard
          </Link>
          
          <button 
            className="btn btn-outline-secondary"
            onClick={() => window.history.back()}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Volver
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound